import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { PAYMENT_STATUS_COLORS, formatStatusLabel, formatNumber } from "../constants";

interface OrderStatusChartProps {
  data: any;
  loading: boolean;
}

const OrderStatusChart = ({ data, loading }: OrderStatusChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="40%" height={24} />
          <Skeleton width="100%" height={280} sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = data?.byStatus
    ? Object.entries(data.byStatus).map(([status, count]) => ({
        name: formatStatusLabel(status),
        value: count as number,
        color: PAYMENT_STATUS_COLORS[status] || "#94a3b8",
      }))
    : [];

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Orders by Payment Status
        </Typography>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" tick={{ fontSize: 10 }} angle={-25} textAnchor="end" height={60} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip
                formatter={(value: any) => [formatNumber(value), "Orders"]}
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={35}>
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No order data</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default OrderStatusChart;
